import { Fade, Grid, Box, Divider, Typography, Button, Alert } from '@mui/material';
import { FC } from 'react';
import { Modal } from '../../../components';

type IConfirmModal = {
  onConfirm: () => void;
  onCancel: () => void;
  handleClose: () => void;
  isOpen: boolean;
};

export const ConfirmModal: FC<IConfirmModal> = ({ onConfirm, onCancel, isOpen, handleClose }) => {
  const onClose = () => {
    handleClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={() => {
        onClose();
      }}
      maxWidth="sm"
    >
      <Fade in={isOpen}>
        <Box>
          <Box marginBottom="0.5rem">
            <Typography variant="h5">Confirm Changes</Typography>
          </Box>
          <Box marginBottom="0.5rem">
            <Divider />
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Alert severity={'warning'}>
                Are you sure you want to save changes? This will update the Build Details as well.
              </Alert>
            </Grid>
          </Grid>
          <Box
            className={'print--none'}
            display="flex"
            marginTop="1rem"
            paddingBottom="1rem"
            width={{
              xs: '100%',
              sm: 'auto'
            }}
          >
            <Button
              variant="contained"
              onClick={() => {
                onConfirm();
              }}
              fullWidth
            >
              Confirm
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                onCancel();
              }}
              fullWidth
            >
              Close
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};
